<template>
	<div class="navbar-container">
		<img :src="logoUrl" class="header-logo-icon logo-bgs" />
		<div class="navbar-right-menu">
			<el-badge is-dot class="badge-sitem" :hidden="msgqty > 0 ? false : true">
				<img src="../assets/images/notice.png" class="notice-icon" @click="openMessage($event)" />
			</el-badge>

			<!-- 客服按钮 -->
			<div class="icon-button" @click="openChat">
				<img src="../assets/images/customer-service.png" width="18" height="18" class="icon-img" />
			</div>

			<!-- 查看商店按钮 -->
			<!-- <div class="icon-button" @click="viewStore"> -->
			<!--        <img src="../assets/images/view-store.png" class="icon-img" />-->
			<div class="icon-text" @click="goStore()">{{$t('common.viewshop')}}</div>
			<!-- </div> -->

			<!-- 设置按钮 -->
			<div class="icon-button" @click="openSettings">
				<img src="../assets/images/settings.png" width="18" height="18" class="icon-img" />
			</div>
			<!--			<div class="Security-deposit-block">店铺余额: ${{balance}}</div>-->

<!--			<el-dropdown trigger="click">
				<div class="lang-container">
					<img :src="langIcon" class="lang-icon" />
					<el-dropdown-menu slot="dropdown">
						<template v-for="(item,index) in langList">
							<el-dropdown-item>
								<div class="lang-dropdown-item" @click="changeLang(index)">
									<img :src="item.icon" class="lang-icon2" />
									<span>{{item.name}}</span>
								</div>
							</el-dropdown-item>
						</template>
			
					</el-dropdown-menu>
				</div>
			</el-dropdown>-->

			<div class="avatar-inner">
				<el-dropdown trigger="click">
					<span>A</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item>
							<el-button type="text" size="mini" @click="openPage('infos')">{{$t('common.userprofile')}}</el-button>
						</el-dropdown-item>
						<el-dropdown-item>
							<el-button type="text" size="mini" @click="handleLogout">{{$t('login.loginout')}}</el-button>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>

		</div>

		<div class="message-pop-mask" v-if="showMessage" @click="closeMessage"></div>
		<div ref="messageRef" class="message-pop-container" :class="showMessage ? 'message-pop-show' : ''">
			<div class="message-pop-header">
				<span>System notification</span>
				<span class="more-txt" @click="openPage('notice')">{{$t('button.more')}}</span>
			</div>
			<div class="message-pop-lists">
				<template v-if="messageLists.length > 0">
					<div class="message-items" v-for="item in messageLists" @click="openInfos(item)">
						<div class="m-titles">
							<div class="m-titles-txt">{{item.noticeTitle}}</div>
							<el-tag type="danger" size="mini" effect="dark"
								v-if="item.status == '0' || item.status === 0">{{$t('button.new')}}</el-tag>
						</div>
						<div class="m-contents">{{item.noticeContent}}</div>
						<div class="m-times">{{item.createTime}}</div>
					</div>
				</template>
				<template v-else>
					<empty></empty>
				</template>
			</div>
		</div>
		<el-dialog :append-to-body="true" :title="messageInfos.noticeTitle" :visible.sync="dialogVisible"
			:width="isMobile ? '90%' : '600px'" :before-close="handleClose">
			<span>{{messageInfos.noticeContent}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="closeInfos">{{$t('button.ok')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { logOut,getlogo } from '@/api/api'
	import { storeUrl } from '@/api/api'
	import { newNoticeList,getNoticeQty,queryMsgdtl } from '@/api/message'
	import empty from './empty.vue'
	export default {
		components: {
			empty
		},
		data() {
			return {
				langIndex: 0,
				storeUrl: '',
				langList: [{
						name: 'English',
						icon: require('@/assets/images/lang/en.png'),
						code: 'en'
					},
					{
						name: '中文',
						icon: require('@/assets/images/lang/cn.png'),
						code: 'zh'
					},
					{
						name: '中文繁體',
						icon: require('@/assets/images/lang/cn.png'),
						code: 'zhTw'
					}
				],
				langIcon: '',
				balance: 0,
				MeiQiaconfig: {
					enterpriseId: '05b657b035753fd4d2ee3ea6d6d0c12e',
					visitorId: '',
					visitorName: '大范围',
					visitorTel: '',
					visitorEmail: ''
				},
				initialized: false,
				showMessage: false,
				msgqty: 0,
				cqty: 0,
				addOrderqty: 0,
				messageLists: [],
				messageInfos: {},
				dialogVisible: false,
				isMobile: false,
				logoUrl: '',
				webName: '',
				kefuiurl: ''
			};
		},

		methods: {
			initLogo() {
				var that = this;
				let params = {}
				getlogo(params).then(res => {
					if (res.code == 200) {
						that.logoUrl = res.data.logourl
						that.webName = res.data.webname
						this.kefuiurl = res.data.kefuiurl
					}
				})
			},
			goStore() {
				//console.log(11111)
				//console.log('storeUrl', this.storeUrl)
				window.open(this.storeUrl);
			},
			getStoreUrl() {
				let domainWithPort = window.location.hostname
				if (window.location.port) {
					domainWithPort += ":" + window.location.port
				}
				let params = {
					domainname: domainWithPort
				}
				storeUrl(params).then(res => {
					if (res.code == 200) {
						this.storeUrl = res.data.storeUrl
						localStorage.setItem("storeUrl", this.storeUrl);


					}
				});
			},
			openCustomerService() {


			},
			viewStore() {},
			openSettings() {
				// 跳转到设置页面
				this.$router.push('/setting');
			},
			changeLang(e) {
				this.langIndex = e
				var lang = this.langList[e].code
				var icon = this.langList[e].icon
				this.$i18n.locale = lang
				localStorage.setItem("lang", lang);
				localStorage.setItem("langIcon", icon);
				location.reload()
			},
			handleLogout() {
				// 清除本地存储的token
				logOut().then(res => {
					if (res.code == 200) {
						// 清除本地存储的token
						localStorage.removeItem('token');
						localStorage.removeItem('fullName');
						localStorage.removeItem('email');
						// 跳转到登录页面
						this.$router.push('/login');
					}
				});
				// 跳转到登录页面
				this.$router.push('/login');
			},
			setupMeiQiaEvents() {
				// 监听美洽聊天窗口打开事件
				window._MEIQIA('on', 'chat', (data) => {
					console.log('美洽聊天窗口状态:', data);
				});

				// 监听消息接收事件
				window._MEIQIA('on', 'message', (data) => {
					console.log('收到新消息:', data);
				});
			},

			openChat() {
				// 方案1: 直接在新窗口打开链接
				window.open(this.kefuiurl, '_blank');

				// 方案2: 如果需要替换当前页面
				// window.location.href = 'https://chatlink.chatslink.net/widget/standalone.html?eid=caf4cef6e77d4e298b720d9fc4ea0ac9&agentid=aab4f04aa2b7ce0edbb3d5a261b2d210&language=en';

				// 方案3: 如果仍需保留美洽功能作为备选
				/*
				try {
				  window._MEIQIA('showPanel');
				} catch (error) {
				  console.error('打开客服面板失败:', error);
				  // 失败时跳转到指定链接
				  window.open('https://chatlink.chatslink.net/widget/standalone.html?eid=caf4cef6e77d4e298b720d9fc4ea0ac9&agentid=aab4f04aa2b7ce0edbb3d5a261b2d210&language=en', '_blank');
				}
				*/
			},
			openMessage(event) {
				const element = event.currentTarget;
				// const rect = element.getBoundingClientRect();
				// const top = rect.bottom + 5
				// const right = rect.right + 20
				// const left = right - 300
				this.showMessage = true
				//this.$refs.messageRef.style = `opacity:1`
			},
			closeMessage() {
				this.showMessage = false
				//this.$refs.messageRef.style = `opacity:0;`
			},
			getMessage() {
				var that = this
				newNoticeList().then(res => {
					if (res.code == 200) {
						that.messageLists = res.data.list
					}
				});
			},
			getUnread() {
				getNoticeQty().then(res => {
					if (res.code == 200) {
						this.msgqty = res.data.qty
						this.cqty = res.data.cqty
						this.addOrderqty = res.data.addOrderqty
						// 将 cqty 保存到 localStorage
						localStorage.setItem('cqty', this.cqty);
						localStorage.setItem('addOrderqty', this.addOrderqty);
						this.$emit('handleBrage')
					}
				});
			},
			openInfos(e) {
				var that = this
				var params = {
					noticeId: e.noticeId,
				}
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.3)'
				});
				queryMsgdtl(params).then(res => {
					loading.close();
					if (res.code == 200) {
						if (e.noticeType == '3' || e.noticeType == '4' || e.noticeType == '5' || e.noticeType ==
							'6') {
							that.openPage('order-infos?orderNo=' + e.orderNo)
						} else {
							that.messageInfos = res.data
							that.dialogVisible = true
						}
					} else {
						that.$message({
							message: 'fail!',
							type: 'warning'
						});
					}
				});
			},
			closeInfos() {
				this.dialogVisible = false
			},
			handleClose(done) {
				done()
			}

		},
		mounted() {
			// 每隔5秒执行一次getUnread方法
			this.unreadTimer = setInterval(() => {
				this.getUnread();
			}, 5000);
		},
		beforeUnmount() {
			clearInterval(this.unreadTimer)
			this.unreadTimer = null
		},
		created() {
			this.initLogo()
			this.getStoreUrl();
			this.getUnread()
			this.getMessage()
			this.langIcon = localStorage.getItem('langIcon') ? localStorage.getItem('langIcon') : require(
				'@/assets/images/lang/en.png');
		},
	};
</script>

<style scoped>
	.navbar-container {
		padding: 10px 30px 10px 15px;
		width: 100%;
		height: 60px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #fff;
		box-shadow: 0 4px 4px -4px rgba(0, 21, 41, 0.08);
		position: fixed;
		top: 0;
		background-color: #fff;
		z-index: 3;
	}

	.header-logo-icon {
		width: 293px;
		height: 40px;
	}

	.navbar-right-menu {
		display: flex;
		align-items: center;
		overflow: hidden;
		justify-content: flex-end;
		gap: 15px;
	}

	.navbar-right-menu .avatar-inner {
		width: 36px;
		height: 36px;
		line-height: 36px;
		border-radius: 50px;
		background-color: #DBE9FD;
		font-size: 16px;
		text-align: center;
		color: #5C71F8;
		cursor: pointer;
	}

	.badge-sitem {
		margin: 4px 0 0;
	}

	.notice-icon {
		width: 20px;
		height: 20px;
		cursor: pointer;
	}

	.Security-deposit-block {
		font-size: 14px;
		color: #5C71F8;
	}

	.lang-icon {
		height: 11px;
		cursor: pointer;
	}

	.lang-dropdown-item {
		display: flex;
		align-items: center;
	}

	.lang-dropdown-item .lang-icon2 {
		height: 11px;
		margin-right: 10px;
	}

	@media (max-width: 767px) {
		.header-logo-icon {
			width: 193px;
			height: 40px;
		}

		.navbar-right-menu .avatar-inner {
			display: none;
		}

		.Security-deposit-block {
			display: none;
		}
	}

	.icon-button {
		display: flex;
		align-items: center;
		gap: 5px;
		cursor: pointer;
		padding: 5px;

	}

	.icon-svg {
		width: 14px;
		height: 14px;
		fill: none;
		stroke: currentColor;
		stroke-width: 2;
	}

	.icon-text {
		font-size: 15px;
		color: #333;
	}

	.message-pop-mask {
		width: 100%;
		height: 100vh;
		z-index: 1060;
		background: rgba(0, 0, 0, 0.0);
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	}

	.message-pop-container {
		width: 300px;
		max-height: 70vh;
		background-color: #fff;
		border-radius: 6px;
		position: fixed;
		overflow-y: scroll;
		opacity: 1;
		box-shadow: 0 6px 12px rgba(0, 0, 0, .18);
		border: 1px solid #eee;
		z-index: 1061;
		display: none;
		top: 45px;
		right: 205px;
	}

	.message-pop-show {
		display: block;
	}

	.message-pop-header {
		width: 100%;
		height: 35px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 15px;
		padding: 20px 15px 10px;
	}

	.message-pop-header .more-txt {
		font-size: 12px;
		color: #999;
		cursor: pointer;
	}

	.message-pop-lists {
		width: 100%;
		height: auto;
		padding: 5px 15px;
		overflow: hidden;
	}

	.message-items {
		width: 100%;
		height: auto;
		overflow: hidden;
		border-bottom: 1px solid #eee;
		font-size: 12px;
		color: #888;
		padding: 9px 0;
		cursor: pointer;
	}

	.message-items:last-child {
		border: unset;
	}

	.message-items .m-titles {
		width: 100%;
		height: 20px;
		font-size: 14px;
		color: #212121;
		display: flex;
		align-content: center;
	}

	.message-items .m-titles-txt {
		float: left;
		width: calc(100% - 40px);
		height: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.message-items .m-contents {
		width: 100%;
		margin: 6px 0;
		height: 20px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.message-items .m-times {
		font-size: 10px;
		color: #999;
	}

	.message-pop-container::-webkit-scrollbar {
		width: 8px;
		/* 滚动条的宽度 */
	}

	.message-pop-container::-webkit-scrollbar-track {
		background-color: #f1f1f1;
	}

	.message-pop-container::-webkit-scrollbar-thumb {
		background: #999;
		/* 滑块颜色 */
		border-radius: 10px;
		/* 滑块圆角 */
	}

	@media (max-width: 767px) {
		.message-pop-container {
			right: 34px;
		}

		.navbar-container {
			padding: 10px 10px 10px 10px;
		}

		.navbar-right-menu {
			gap: 7px;
		}
	}
</style>
